import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { Types, Variants } from "./constants";
const { text, color, size } = ids || {};
const filledNeutral = css `
  background: ${color.feedbacks.ids_color_feedback_neutral};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const outlinedNeutral = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.feedbacks.ids_color_feedback_neutral};
  background: rgba(0, 0, 0, 0);
  color: ${color.feedbacks.ids_color_feedback_neutral};
`;
const filledPrimary = css `
  background: ${color.action.primary.ids_color_action_primary_base};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const outlinedPrimary = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.action.primary.ids_color_action_primary_base};
  background: rgba(0, 0, 0, 0);
  color: ${color.action.primary.ids_color_action_primary_base};
`;
const filledSucess = css `
  background: ${color.feedbacks.ids_color_feedback_success};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const outlinedSucess = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.feedbacks.ids_color_feedback_success};
  background: rgba(0, 0, 0, 0);
  color: ${color.feedbacks.ids_color_feedback_success};
`;
const filledWarning = css `
  background: ${color.feedbacks.ids_color_feedback_error};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const outlinedWarning = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.feedbacks.ids_color_feedback_error};
  background: rgba(0, 0, 0, 0);
  color: ${color.feedbacks.ids_color_feedback_error};
`;
const filledError = css `
  background: ${color.feedbacks.ids_color_feedback_alert};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const outlinedError = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.feedbacks.ids_color_feedback_alert};
  background: rgba(0, 0, 0, 0);
  color: ${color.feedbacks.ids_color_feedback_alert};
`;
const filledDark = css `
  background: ${color.contrast.ids_color_contrast_onDark};
  color: ${color.feedbacks.ids_color_feedback_neutral};
`;
const outlinedDark = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.contrast.ids_color_contrast_onDark};
  background: rgba(255, 255, 255, 0);
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const getBadgeKindStyle = (type, variant, contrast) => {
    if (contrast === Contrast.dark)
        return variant === Variants.outlined ? outlinedDark : filledDark;
    switch (type) {
        case Types.neutral:
            return variant === Variants.outlined ? outlinedNeutral : filledNeutral;
        case Types.primary:
            return variant === Variants.outlined ? outlinedPrimary : filledPrimary;
        case Types.success:
            return variant === Variants.outlined ? outlinedSucess : filledSucess;
        case Types.error:
            return variant === Variants.outlined ? outlinedError : filledError;
        case Types.warning:
            return variant === Variants.outlined ? outlinedWarning : filledWarning;
        default:
            return variant === Variants.outlined ? outlinedNeutral : filledNeutral;
    }
};
export const StyledInformativeTag = styled.div `
  ${{ ...text.body.ids_textStyle_caption_regular }};
  border: 0px none;
  border-radius: ${size.corner_radius.ids_size_cornerRadius_tags_01};
  display: inline-block;
  height: ${size.general.ids_size_general_20x};
  padding: 0 ${size.general.ids_size_general_8x};
  text-align: center;
  ${({ type, variant, contrast }) => getBadgeKindStyle(type, variant, contrast)}
`;
//# sourceMappingURL=InformativeTag.style.js.map